import React from 'react';

import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 節見出し（thoughts-ai の SectionHeading 相当）。章の中の小見出し。
 * params: title（必須）
 */
export const ProseHeading: React.FC<KnzComponentProps> = ({ node }) => {
  const title = (node.params.title as string) ?? '';
  return (
    <Typography
      component="h3"
      sx={{
        fontSize: 15,
        fontWeight: 700,
        fontFamily: SERIF_FONT,
        color: '#1A1A1A',
        mt: 3,
        mb: 1.5,
        lineHeight: 1.6,
      }}
    >
      {title}
    </Typography>
  );
};

export default ProseHeading;
